import Fundatio from "../../../layouts/apps/Fundatio";
import LinkedText from "../../../components/LinkedText";
import IconText from "../../../components/IconText";
import {faEnvelope, faHandHoldingMedical, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";

export default function FundatioSupport() {
    const rightContent = (
        <div>
            <h1><IconText icon={faHandHoldingMedical} text="Get Direct Help"></IconText></h1>
            <p>For technical issues, questions, or feature requests, contact me directly:</p>
            <LinkedText text={"cagri@mpospirit.com"} href={"mailto:cagri@mpospirit.com"} icon={faEnvelope}></LinkedText>

            <h1><IconText icon={faQuestionCircle} text={"FAQ"}></IconText></h1>
            <h3>Q: How do I install Fundatio?</h3>
            <p>Using Apple App Store.</p>

            <h3>Q: Do I need to be online to use Fundatio?</h3>
            <p>No, Fundatio works completely offline after installation.</p>

            <h3>Q: Is my data private?</h3>
            <p>Yes, all your data is stored locally on your device and never sent to any servers.</p>

            <h3>Q: Where can I get an API key to use AI features?</h3>
            <p>Fundatio supports OpenAI, Anthropic, Mistral, and Deepseek AI services. You can get API keys by signing
                up on their respective websites.</p>

            <h3>Q: Is Fundatio completely free?</h3>
            <p>Yes.</p>
        </div>
    );

    return (
        <div className="cogio-support-page">
            <Fundatio rightContent={rightContent}/>
        </div>
    )
}